import { labFragment } from 'apollo/fragments/organization';
import { gql } from 'graphql.macro';

export const addLabTemplate = gql`
    mutation addLab($lab: LabInput!) {
        addLab(lab: $lab) {
            ...labFields
        }
    }
    ${labFragment}
`;

export const modifyLabTemplate = gql`
    mutation modifyLab($labId: MongoDbObjectId!, $lab: LabInput!) {
        modifyLab(labId: $labId, lab: $lab) {
            ...labFields
        }
    }
    ${labFragment}
`;

export const saveTransportSettingsTemplate = gql`
    mutation saveTransportSettings($labId: MongoDbObjectId!, $transportSettings: TransportSettingsInput!) {
        saveTransportSettings(labId: $labId, transportSettings: $transportSettings) {
            _id
        }
    }
`;

export const syncHitHorizonsOrganizationTemplate = gql`
    mutation syncHitHorizonsOrganization($organizationId: MongoDbObjectId!, $syncData: HitHorizonsSyncInput!) {
        syncHitHorizonsOrganization(organizationId: $organizationId, syncData: $syncData) {
            _id
        }
    }
`;

export const saveOrganizationCustomerSettingsTemplate = gql`
    mutation saveOrganizationCustomerSettings($organizationId: MongoDbObjectId!, $settings: [CustomerSettingInput!]!) {
        saveOrganizationCustomerSettings(organizationId: $organizationId, settings: $settings) {
            success
            errors {
                field
                message
            }
        }
    }
`;
